<button
  type="button"
  class="wrapper"
  tabindex="0"
  [class.active]="expanded"
  [class.padding-no-dropdown]="!dropdown">
  <mg-icon
    class="main-icon"
    [iconName]="icon"></mg-icon>
  <mg-icon
    *ngIf="dropdown"
    class="dropdown-icon"
    [iconName]="expanded ? 'mg-chevron-up' : 'mg-chevron-down'"></mg-icon>
</button>
